export type AddonSuspendType = "CLOUD_SUSPENDED" | "ADDONS_SUSPENDED";

export interface AddonAttributes {
    id: string;
    name: string;
    entitlement_type?: string;
    life_time?: string;
}

export class Addon {
    readonly id: string;
    readonly name: string;
    readonly entitlement_type?: string;
    readonly life_time?: string;

    constructor(attrs: AddonAttributes) {
        this.id = attrs.id;
        this.name = attrs.name;
        this.entitlement_type = attrs.entitlement_type;
        this.life_time = attrs.life_time;
    }
}

export default Addon;